<template>
  <div>
    <PatientListDeIdent></PatientListDeIdent>
  </div>
</template>

<script>
import PatientListDeIdent from '../components/PatientListDeIdent'

export default {
  components: {
    PatientListDeIdent
  }
}
</script>
